import { apiService } from './apiService';

export function getTaxService(data) {
    return apiService({
        method: 'POST',
        url: '/tax/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdTaxService(id) {
    return apiService({
        method: 'GET',
        url: '/tax/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addTaxService(data) {
    return apiService({
        method: 'POST',
        url: '/tax',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateTaxService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/tax/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteTaxService(id) {
    return apiService({
        method: 'DELETE',
        url: '/tax/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
